var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestbanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 124,
    viewBox: "0 0 194 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 95.3984H43.5005V123.429H28.0303C20.5962 123.429 13.4667 120.476 8.21001 115.219C2.95329 109.962 0 102.833 0 95.3984Z",
    fill: "#6D55F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3229 102.508L60.2194 123.54H48.617C44.1135 123.54 39.7945 121.751 36.6101 118.567C33.4256 115.382 31.6367 111.063 31.6367 106.56L50.0535 95.5098L68.3229 102.508Z",
    fill: "url(#paint0_linear_2328_41388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.608 19.7432L104.865 95.4362H0C0 75.3612 7.97489 56.1082 22.1701 41.913C36.3653 27.7178 55.618 19.7432 75.6931 19.7432H104.608Z",
    fill: "#FFE6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.75 69.3945L155.367 123.466H193.085C193.065 109.151 187.377 95.4254 177.265 85.2923C167.153 75.1593 153.439 69.4432 139.123 69.3945H92.75Z",
    fill: "#FFF5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.448 41.8428H50.0195V106.707H133.448V41.8428Z",
    fill: "url(#paint1_linear_2328_41388)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8906 123.466C33.3302 111.071 42.2615 100.529 53.5939 93.1264C64.9263 85.7241 78.1692 81.7822 91.7049 81.7822C105.241 81.7822 118.484 85.7241 129.816 93.1264C141.148 100.529 150.079 111.071 155.519 123.466H27.8906Z",
    fill: "url(#paint2_linear_2328_41388)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8686 46.5574C63.8686 42.9054 64.5879 39.2893 65.9855 35.9153C67.383 32.5414 69.4313 29.4756 72.0136 26.8933C74.596 24.311 77.6617 22.2625 81.0357 20.8649C84.4097 19.4673 88.026 18.748 91.6779 18.748L119.524 46.5574V60.4438C119.262 67.6489 116.215 74.4715 111.025 79.4761C105.835 84.4808 98.9063 87.2774 91.6964 87.2774C84.4864 87.2774 77.5573 84.4808 72.3673 79.4761C67.1772 74.4715 64.1308 67.6489 63.8686 60.4438L61.6953 54.7712L63.8686 46.5574Z",
    fill: "url(#paint3_linear_2328_41388)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.828 69.8001C104.826 71.8103 102.447 73.4054 99.8268 74.4938C97.2068 75.5822 94.3974 76.1424 91.5604 76.1424C88.7233 76.1424 85.9142 75.5822 83.2941 74.4938C80.6741 73.4054 78.295 71.8103 76.293 69.8001L78.9449 67.1113C82.2797 70.4357 86.7963 72.3025 91.5051 72.3025C96.2138 72.3025 100.731 70.4357 104.065 67.1113L106.828 69.8001Z",
    fill: "url(#paint4_linear_2328_41388)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7585 0.147478C102.817 0.147478 113.422 4.54041 121.242 12.3599C129.061 20.1793 133.454 30.7848 133.454 41.8432V60.26C133.458 58.4349 133.102 56.6268 132.407 54.9393C131.712 53.2518 130.691 51.7178 129.402 50.4253C126.783 47.8366 123.25 46.3815 119.568 46.3737H116.989C116.443 43.9117 115.071 41.7107 113.101 40.1362C111.131 38.5616 108.682 37.7084 106.16 37.7178C104.265 37.7124 102.401 38.1942 100.746 39.1173C97.9264 36.5313 95.6724 33.3902 94.1258 29.8911C92.5791 26.3921 91.7733 22.6109 91.7585 18.7853C84.3893 18.7853 77.3214 21.7102 72.1072 26.9175C66.893 32.1248 63.9586 39.1886 63.9489 46.5578L59.4922 55.0663C56.7404 54.1396 54.3494 52.3715 52.6573 50.0118C50.9653 47.6522 50.0576 44.8203 50.0628 41.9167C50.0434 36.4253 51.107 30.984 53.1929 25.904C55.2787 20.8241 58.3457 16.2055 62.2185 12.3122C66.0913 8.41891 70.6936 5.3275 75.7624 3.21485C80.8313 1.1022 86.267 0.00965091 91.7585 0V0.147478Z",
    fill: "#925B54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8671 46.5566V60.443C62.6851 60.443 61.5513 59.9733 60.7154 59.1375C59.8796 58.3017 59.4102 57.1681 59.4102 55.986V51.1977C59.4172 50.0155 59.8788 48.8813 60.6992 48.0301C61.1164 47.6172 61.6111 47.2907 62.1547 47.0694C62.6983 46.8482 63.2802 46.7365 63.8671 46.7408V46.5566Z",
    fill: "url(#paint5_linear_2328_41388)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8678 40.5908H86.4805",
    stroke: "#212240",
    strokeWidth: 1.11
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.307 58.5648C112.451 58.5648 117.431 53.5845 117.431 47.441C117.431 41.2975 112.451 36.3174 106.307 36.3174C100.164 36.3174 95.1836 41.2975 95.1836 47.441C95.1836 53.5845 100.164 58.5648 106.307 58.5648Z",
    fill: "url(#paint6_linear_2328_41388)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0926 58.5648C83.2361 58.5648 88.2162 53.5845 88.2162 47.441C88.2162 41.2975 83.2361 36.3174 77.0926 36.3174C70.9491 36.3174 65.9688 41.2975 65.9688 47.441C65.9688 53.5845 70.9491 58.5648 77.0926 58.5648Z",
    fill: "url(#paint7_linear_2328_41388)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5664 53.7773L42.281 49.0625L46.9958 53.7773L42.281 58.5288L37.5664 53.7773Z",
    fill: "#6D55F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6758 67.9587L57.3906 63.2441L62.1421 67.9587L57.3906 72.6735L52.6758 67.9587Z",
    fill: "#8FCEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4607 44.3471L52.7461 39.5954L57.4607 34.8809L62.1755 39.5954L57.4607 44.3471Z",
    fill: "#FFAD83"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7556 95.3986C49.7556 98.3292 48.5915 101.14 46.5192 103.212C44.4469 105.285 41.6362 106.449 38.7055 106.449H31.707V101.734C31.707 100.062 32.0371 98.4065 32.678 96.8623C33.3189 95.3182 34.2582 93.9157 35.4421 92.7352C36.626 91.5547 38.0311 90.6195 39.5771 89.983C41.1231 89.3466 42.7797 89.0216 44.4516 89.0264H62.6105C62.5911 90.7134 61.9073 92.3245 60.7075 93.5106C59.5076 94.6966 57.8886 95.3618 56.2015 95.3617H49.8293",
    fill: "url(#paint8_linear_2328_41388)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.307 58.5648C112.451 58.5648 117.431 53.5845 117.431 47.441C117.431 41.2975 112.451 36.3174 106.307 36.3174C100.164 36.3174 95.1836 41.2975 95.1836 47.441C95.1836 53.5845 100.164 58.5648 106.307 58.5648Z",
    stroke: "#212240",
    strokeWidth: 1.11
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0926 58.5648C83.2361 58.5648 88.2162 53.5845 88.2162 47.441C88.2162 41.2975 83.2361 36.3174 77.0926 36.3174C70.9491 36.3174 65.9688 41.2975 65.9688 47.441C65.9688 53.5845 70.9491 58.5648 77.0926 58.5648Z",
    stroke: "#212240",
    strokeWidth: 1.11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2328_41388",
    x1: 49.4833,
    y1: 97.5437,
    x2: 53.2092,
    y2: 119.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2328_41388",
    x1: 101.59,
    y1: 45.7191,
    x2: 96.5111,
    y2: 94.0614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#603838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925B54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2328_41388",
    x1: 86.7802,
    y1: 45.34,
    x2: 86.7802,
    y2: 118.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E845E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69D1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2328_41388",
    x1: 89.2501,
    y1: 12.6668,
    x2: 89.2501,
    y2: 72.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2328_41388",
    x1: 88.1051,
    y1: 83.4819,
    x2: 88.1318,
    y2: 77.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2328_41388",
    x1: 62.5617,
    y1: 38.2197,
    x2: 67.3588,
    y2: 44.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCCBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2328_41388",
    x1: 100.772,
    y1: 66.4266,
    x2: 100.772,
    y2: 41.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2328_41388",
    x1: 71.5571,
    y1: 66.4266,
    x2: 71.5571,
    y2: 41.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2328_41388",
    x1: 52.4827,
    y1: 110.09,
    x2: 49.3126,
    y2: 116.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BBA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCCBA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestbanner);
export default __webpack_public_path__ + "static/media/testbanner.2ad6256546b77ef7f26280d63ad4e11a.svg";
export { ForwardRef as ReactComponent };